export default __webpack_public_path__ + "static/media/0105.6bce8343.jpg";